// Canonical production origin — used to build absolute URLs for canonical
// links, Open Graph/Twitter tags, and the sitemap. Matches ALLOWED_ORIGIN in
// BACKEND/config.php and .env.production.
export const SITE_URL = "https://www.fivelightsreno.com";

export const SITE_NAME = "Five Lights Reno";

// Fallback share card for any page that doesn't set its own image: a proper
// 1200x630 composition built from the real logo, a real project photograph and
// the real service areas. Regenerate it rather than hand-editing — the source
// is a small Playwright script kept with the QA tooling, and the card must
// stay 1200x630 or every platform will crop it differently.
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.jpg`;
